import React, { useEffect } from "react";

// Desktop Image
import desktopImg from "../../Assets/Images/NewsletterImages/img.webp";

// Mobile Image
import mobileImg from "../../Assets/Images/NewsletterImages/img1.webp";

const NewsLetter = () => {
  return (
    <>
      {/*  MOBILE VIEW  */}
      <div className="relative md:hidden px-4 bg-[#FFFAF9]">
        <img
          data-aos="zoom-in-down"
          src={mobileImg}
          alt="Newsletter Mobile"
          className="w-full h-auto object-cover"
        />

        <div
          data-aos="zoom-in-up"
          className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 space-y-4 py-2"
        >
          <h1 className="font-philosopher text-3xl text-white">
            Subscribe to Our Newsletter
          </h1>

          <p className="font-robotoflex text-sm w-60 text-white">
            Stay connected with the world of beauty and self-care! Subscribe to
            our newsletter and get latest updates and offers.
          </p>

          <div className="rounded-md border-accentTextColor/50 border flex items-stretch overflow-hidden w-[70%]">
            <input type="email" name="email" id="email" placeholder="Enter your email" className="px-2 py-2 outline-none placeholder:text-white placeholder:text-sm text-gray-200 bg-white/20 backdrop-blur-sm w-[80%]" />
            <button className="w-20 md:w-32 font-robotoflex text-xs md:text-base text-white rounded-tr-md rounded-br-md px-4 py-2 xl:py-3 bg-[#2C1F1B] transition-all duration-300">
              Subscribe
            </button>
          </div>
        </div>
      </div>

      {/*  DESKTOP VIEW  */}
      <div className="bg-[#FFFAF9] w-full h-[34rem] relative hidden md:block ">
        {/* CENTERED CONTAINER */}
        <div className="relative mx-auto  px-4 md:px-8 lg:px-12  h-full">
          {/* IMAGE */}
          <img
            data-aos="zoom-in-down"
            src={desktopImg}
            alt="Newsletter Desktop"
            className="w-full h-[30rem] object-fill rounded-xl"
          />

          {/* TEXT OVERLAY */}
          <div
            data-aos="zoom-in-up"
            className="absolute inset-0 top-20  flex items-center justify-center"
          >
            <div className="flex flex-col items-center text-center space-y-4 lg:space-y-6">
              <h1 className="font-philosopher font-bold text-xl md:text-3xl lg:text-4xl xl:text-5xl text-white">
                Subscribe to Our Newsletter
              </h1>

              <p className="font-robotoflex font-thin max-w-xl text-white text-sm lg:text-lg">
                Stay connected with the world of beauty and self-care! Subscribe
                to our newsletter and be the first to discover our latest
                services, exclusive offers, seasonal beauty tips, and expert
                recommendations from our stylists.
              </p>

              <div className="rounded-md border-accentTextColor/50 border flex items-stretch overflow-hidden">
                <input type="email" name="email" id="email" placeholder="Enter your email" className="px-3 py-3 outline-none placeholder:text-white text-gray-200 bg-white/20 backdrop-blur-sm w-[80%]" />
                <button className="w-20 md:w-32 font-robotoflex text-xs md:text-base text-white rounded-tr-md rounded-br-md px-4 py-2 xl:py-3 bg-[#2C1F1B] transition-all duration-300">
                  Subscribe
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsLetter;
